var _path, _path2, _circle, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsermanualNormalstate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.692627 3C0.692627 1.89543 1.58806 1 2.69263 1H16.8926V15.4H15.9926H2.66299C1.99429 15.4 1.36983 15.7342 0.998894 16.2906L0.692627 16.75V3Z",
    stroke: "#747474",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.692627 17.2C0.692627 16.2059 1.49851 15.4 2.49263 15.4H16.8926C15.2116 16.0113 15.2116 18.3887 16.8926 19H2.49263C1.49851 19 0.692627 18.1941 0.692627 17.2Z",
    stroke: "#747474",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.63635,
    cy: 4.54376,
    r: 0.84375,
    fill: "#747474"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.07385,
    y: 6.88751,
    width: 1.125,
    height: 6,
    fill: "#747474"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsermanualNormalstate);
export default __webpack_public_path__ + "static/media/User manual _ normal state.ba3b9246a052cc6cb51822306d299668.svg";
export { ForwardRef as ReactComponent };